import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    localStorage.setItem("vs_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const loginMobile = async (mobile, pin, remember = false) => {
    const { data } = await api.post("/auth/login-mobile", { mobile, pin, remember });
    localStorage.setItem("vs_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  // Used by the activation / setup flows that return a fresh { access_token, user }.
  const setSession = (data) => {
    localStorage.setItem("vs_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("vs_token");
    setUser(false);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      return null;
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, login, loginMobile, setSession, logout, refreshUser, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
